<template>
  <div class="c-w-93 m-auto px-3 report-progress-container">
    <!-- HEADER -->
    <div
      class="is-sticky bg-white pt-2 pb-1 scaled-wrapper"
      :class="{ 'border-bottom-1': isLittleScroll }"
      :style="{ top: navbarPosition, marginBottom: '-4px' }"
    >
      <HeaderProgress
        :loadAPI="getReportProgress"
        :isLittleScrollProps="isLittleScroll"
        @updateZoom="updateZoom"
      />
    </div>

    <!-- SUMMARY -->
    <!-- <div class="mt-2 scaled-summary">
      <div class="summary-progress">
        <SummaryProgress
          :data="dataSummary"
          :isEmpty="dataProgress.length < 1"
          :isLoading="isLoading"
        />
      </div>
    </div> -->

    <!-- <transition name="fade" mode="out-in"> -->
    <div v-if="isLoading" class="c-w-100 min-h-50vh flex-center" key="loading-1">
      <SpinnerIcon />
    </div>
    <div v-else-if="!isLoading && dataProgress.length > 0" class="is-relative" key="main-1">
      <div
        ref="scrollTableContainer"
        class="table-container border-radius-top-10 mb-2"
        :style="{
          maxHeight: '72vh'
        }"
        @scroll="handleScrollTableContainer"
      >
        <div
          :style="{
            width: widthTableComputed,
            zoom: `${scaleTable}`
          }"
          class="is-relative transform-origin-top-left border-bottom-1"
        >
          <!-- NAVBAR SECTION -->
          <div class="sticky-top z-index-10">
            <NavbarTableProgress
              ref="navbarProgress"
              :heightColumnNavProps="heightColumnNavStatus"
              :widthColumnNavProps="widthColumnNav"
              :widthColumnProps="widthColumn"
              :scaleTableProps="scaleTable"
              :dataSummary="dataSummary"
              :dateSummary="dateSummary"
              :minWidthSideColumn="minWidthSideColumn"
            />
          </div>

          <!-- v-for="(itemMonth, indexMonth) in dataProgress" -->
          <!-- :key="`item-month-${indexMonth}`" -->
          <div v-if="!filterSummary" class="monthly-wrap">
            <div
              v-for="(itemWeek, indexWeek) in dataProgress"
              :key="`item-week-${indexWeek}`"
              class="weekly-wrap"
            >
              <!-- WEEKLY SECTION -->
              <AccordionWeeklyProgress
                v-if="!isFilterStatus"
                :topAccordion="topAccordion"
                :itemWeekProps="itemWeek"
                :isShrink="isShrink"
                :indexWeekProps="indexWeek"
                :heightColumnDailyProps="heightColumnAccordion"
                :heightColumnNavProps="heightColumnNav"
                :indexAccordionWeekProps="indexAccordionWeek"
                :handleAccordionProps="handleAccordion"
              />

              <!-- SHOW TOTAL MINGGUAN ON CLOSE ACCORDION -->
              <div v-if="!isFilterStatus && indexAccordionWeek.includes(indexWeek)">
                <TotalWeeklyColumnProgress
                  :showHeader="true"
                  :fromCollapse="true"
                  :totalWeekProps="itemWeek.total_week"
                  :heightColumnWeeklyProps="heightColumnWeekly"
                  :widthColumnProps="widthColumn"
                  :widthColumnNavProps="widthColumnNav"
                  :minWidthSideColumn="minWidthSideColumn"
                  :isToday="itemWeek.data.some((d) => d.today)"
                  :scaleTableProps="scaleTable"
                />
              </div>

              <div
                v-if="itemWeek.data.length > 0"
                class="per-section"
                :class="{ close: indexAccordionWeek.includes(indexWeek) }"
              >
                <div
                  v-for="(itemDaily, indexDaily) in itemWeek.data"
                  :key="`item-daily-${indexDaily}`"
                  class="is-flex parent-box"
                  :data-week="indexWeek"
                  :data-daily="indexDaily"
                >
                  <!-- LEFT SECTION -->
                  <!-- :id="`columnDate${indexMonth}${indexWeek}${indexDaily}`" -->
                  <!-- :style="{
                    minHeight: `${
                      heightColumn * itemDaily.project.length +
                      heightColumnDaily -
                      (itemDaily.today ? 14 : 0)
                    }px`
                  }" -->
                  <div
                    :id="`columnDate${indexWeek}${indexDaily}`"
                    class="sticky-left column-date border-right-5 averta-bold"
                    :class="[`jump-${itemDaily.no}`, { 'shrink-side': isShrink }]"
                    :style="{
                      minWidth: `${minWidthSideColumn}px`
                    }"
                  >
                    <!-- :id="`columnDateChild${indexMonth}${indexWeek}${indexDaily}`" -->
                    <div
                      :id="`columnDateChild${indexWeek}${indexDaily}`"
                      :style="{
                        width: `${widthColumnNav}px`,
                        height: `${heightColumn}px`
                      }"
                      class="all-ease-in-out"
                      :class="{
                        today: itemDaily.today
                      }"
                    >
                      <div
                        class="all-ease-in-out column-date-child flex-center-vertical pl-3"
                        :style="{ height: `${heightColumn}px` }"
                      >
                        <div class="is-flex is-flex-direction-column">
                          <p :class="[isShrink ? 'label-22' : 'label-14']">
                            {{ formatDate(itemDaily.date, 'dddd') }},
                          </p>
                          <p class="averta-reguler" :class="[isShrink ? 'label-18' : 'label-14']">
                            {{ formatDate(itemDaily.date, 'DD MMM YYYY') }}
                          </p>
                          <div
                            v-if="itemDaily.today"
                            class="border-radius-100 flex-center py-1 mt-1 bg-light-blue-2"
                            style="width: 65px"
                          >
                            <!-- <div class="bg-blue border-radius-100 ellipse mr-1"></div> -->
                            <p
                              class="averta-bold color-blue-1 has-text-centered"
                              :class="[isShrink ? 'label-14 px-1' : 'label-12']"
                            >
                              Hari Ini
                            </p>
                          </div>
                        </div>

                        <div class="prev-next-wrapper">
                          <!-- v-if="indexWeek > 0 || indexDaily > 0" -->
                          <div
                            class="btn-prev-next prev flex-center color-white"
                            @click="jumpTo('prev', `.jump-${itemDaily.no - 1}`)"
                          >
                            <ChevronIcon color="#000" size="25" />
                          </div>

                          <!-- v-if="
                              indexMonth < dataProgress.length - 1 ||
                              indexWeek < itemMonth.table.length - 1 ||
                              indexDaily + 1 < itemWeek.data.length
                            " -->
                          <div
                            class="btn-prev-next next flex-center color-white"
                            @click="jumpTo('next', `.jump-${itemDaily.no + 1}`)"
                          >
                            <ChevronIcon color="#000" size="25" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="sticky-bottom mt-auto c-w-100"
                      :style="{ bottom: `${isFilterStatus ? 0 : heightColumnWeekly}px` }"
                    >
                      <!-- :style="{bottom: `${heightColumnWeekly * 2}px`}" -->
                      <!-- TOTAL DIALY KESELURUHAN -->
                      <div
                        :style="{
                          width: '100%',
                          height: `${heightColumnDaily}px`
                        }"
                        class="daily-column side flex-center-vertical px-3"
                      >
                        <p
                          class="averta-bold has-text-centered"
                          :class="[isShrink ? 'label-18' : 'label-14']"
                        >
                          Total Harian : <span class="averta-black label-16">{{ countValueInsideArray(itemDaily.total_day) }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="is-flex is-flex-direction-column"
                    :class="{
                      'nav-table-shrink': isShrink
                    }"
                  >
                    <div v-if="itemDaily.project.length > 0">
                      <!-- HERE -->
                      <!-- `${
                        heightColumn * itemDaily.project.length +
                        (heightColumnDaily - heightColumnWeekly) -
                        (itemDaily.today ? 14 : 0)
                      }px` -->
                      <!-- <virtual-list
                        :style="{
                          maxHeight: `${maxHeightTable}vh`,
                          overflowY: 'auto',
                          scrollbarWidth: 'none'
                        }"
                        :data-key="'survey_id'"
                        :data-sources="itemDaily.project"
                        :data-component="listColumn"
                        :extra-props="{
                          indexWeek,
                          indexDaily,
                          idxSelectedStatus,
                          itemDaily: {
                            date: itemDaily.date,
                            today: itemDaily.today,
                            project_length: itemDaily.project.length
                          },
                          dataProgressLength: dataProgress.length,
                          scaleTable,
                          getColumnClassProps: getColumnClass,
                          handleClickArrowProps: handleClickArrow,
                          handleConfirmTooltipProps: handleConfirmTooltip
                        }"
                        :keeps="30"
                        :size="heightColumn"
                      /> -->

                      <div>
                        <ListColumn
                          v-for="(itemProject, indexProject) in itemDaily.project"
                          :key="indexProject"
                          :source="itemProject"
                          :indexWeek="indexWeek"
                          :indexDaily="indexDaily"
                          :idxSelectedStatus="idxSelectedStatus"
                          :itemDaily="{
                            date: itemDaily.date,
                            today: itemDaily.today,
                            project_length: itemDaily.project.length
                          }"
                          :dataProgressLength="dataProgress.length"
                          :scaleTable="scaleTable"
                          :getColumnClassProps="getColumnClass"
                          :handleClickArrowProps="handleClickArrow"
                          :handleConfirmTooltipProps="handleConfirmTooltip"
                          :fromDate="fromDate"
                          :toDate="toDate"
                        />
                      </div>

                      <!-- TOTAL DIALY -->
                      <TotalDailyWeekly
                        :itemDaily="itemDaily"
                        :isFilterStatus="isFilterStatus"
                        :widthColumnProps="widthColumn"
                        :heightColumnWeeklyProps="heightColumnWeekly"
                        :heightColumnDailyProps="heightColumnDaily"
                        :scaleTableProps="scaleTable"
                        :minWidthSideColumn="minWidthSideColumn"
                      />
                    </div>

                    <!-- EMPTY COLUMN (18) -->
                    <div v-else>
                      <EmptyColumnProgress
                        :heightColumnProps="heightColumn"
                        :heightColumnDailyProps="heightColumnDaily"
                        :widthColumnProps="widthColumn"
                      />
                    </div>
                  </div>
                </div>

                <!-- ONLY WEEK SECTION -->
                <!-- <div class="sticky-bottom z-index-5" :style="{bottom: `${heightColumnWeekly}px`}"> -->
                <div class="sticky-bottom z-index-5">
                  <div class="is-flex" v-if="!isFilterStatus">
                    <div
                      class="sticky-left column-date border-right-5 averta-bold"
                      :class="{'shrink-side': isShrink}"
                      :style="{
                        height: `${heightColumnWeekly}px`,
                        minWidth: `${minWidthSideColumn}px`
                      }"
                    >
                      <div class="sticky-bottom mt-auto c-w-100">
                        <TotalWeeklyColumnProgress
                          :showHeader="true"
                          :showColumn="false"
                          :totalWeekProps="itemWeek.total_week"
                          :heightColumnWeeklyProps="heightColumnWeekly"
                          :widthColumnNavProps="widthColumnNav"
                          :isToday="itemWeek.data.some((d) => d.today)"
                          :scaleTableProps="scaleTable"
                        />
                      </div>
                    </div>
                    <div :class="{ 'nav-table-shrink': isShrink }">
                      <TotalWeeklyColumnProgress
                        :totalWeekProps="itemWeek.total_week"
                        :heightColumnWeeklyProps="heightColumnWeekly"
                        :widthColumnProps="widthColumn"
                        :widthColumnNavProps="widthColumnNav"
                        :isToday="itemWeek.data.some((d) => d.today)"
                        :scaleTableProps="scaleTable"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!isFilterStatus && !indexAccordionWeek.includes(indexWeek)">
                <TotalWeeklyColumnProgress
                  :showHeader="true"
                  :totalWeekProps="itemWeek.total_week"
                  :heightColumnWeeklyProps="heightColumnWeekly"
                  :widthColumnProps="widthColumn"
                  :widthColumnNavProps="widthColumnNav"
                  :isToday="itemWeek.data.some((d) => d.today)"
                  :scaleTableProps="scaleTable"
                />
              </div>
            </div>
            <!-- <div class="monthly-report">
                <div class="is-flex">
                  <div
                    class="sticky-left column-date border-right-5 averta-bold"
                    :style="{
                      height: `${heightColumnWeekly}px`
                    }"
                  >
                    <div
                      class="sticky-bottom mt-auto"
                    >
                      <div
                        :style="{ width: `${widthColumnNav}px`, height: `${heightColumnWeekly}px` }"
                        class="monthly-column side flex-center"
                      >
                        <p class="averta-bold label-14 has-text-centered">Total Bulanan : {{countValueInsideArray(itemMonth.total_monthly)}}</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="sticky-bottom mt-auto">
                      <div class="flex-center">
                        <div
                          v-for="month, index in itemMonth.total_monthly"
                          :key="`daily-${index}`"
                          :style="{ width: `${widthColumn}px`, height: `${heightColumnWeekly}px` }"
                          :class="{'border-right-5': index === 1}"
                          class="monthly-column flex-center"
                        >
                          <p class="averta-bold label-14">
                            Selesai : {{month.completed}}
                            <span v-if="itemMonth.table.some(week => week.data?.some(d => d.today)) || index === 13">
                              <span class="label-16">|</span> Belum Selesai : {{month.not_completed}}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
          </div>

          <!-- FILTER FOR SUMMARY -->
          <div v-else-if="filterSummary" class="has-text-centered c-w-100 mb-6">
            <ProyekEmptyIcon height="230" />
            <p class="averta-bold mt-0">Filter Untuk Ringkasan Aktif</p>
          </div>
        </div>
      </div>

      <div class="tooltip-footer flex-center">
        <!-- Scroll Ke Hari Ini -->
        <div
          v-if="showScrollToday && !isLoading && dataProgress.length > 0"
          class="scroll-today flex-center border-radius-100 px-3 py-2 bg-red color-white is-clickable tf-scale-09"
          @click="handleScrollToday"
        >
          <p class="averta-bold">{{ showBackToTop ? 'Kembali ke Atas' : 'Ke hari ini' }}</p>
          <div class="icon-today-wrapper" :class="{ reverse: showBackToTop }">
            <img :src="require('@/assets/img/arrow-upward.png')" height="15" alt="" />
          </div>
        </div>
        <!-- <div class="is-relative">
            <b-dropdown
              v-model="dropdownShortcut"
              aria-role="menu"
              append-to-body
              position="is-top-left"
              :close-on-click="false"
            >
              <template #trigger>
                <div class="calendar-icon flex-center" @click="handleOpenShortcut">
                  <CalendarIcon color="white" size="16" />
                </div>
              </template>
              <div class="p-2">
                <v-date-picker
                  color="red"
                  is-expanded
                  v-model="selectedShortcut"
                  :available-dates="availableDates"
                />
              </div>
            </b-dropdown>
          </div> -->
      </div>
    </div>

    <!-- FILTER FOR SUMMARY -->
    <!-- <div v-else-if="alreadyFiltered" class="has-text-centered">
      <ProyekEmptyIcon height="230" />
      <p class="averta-bold mt-0">Filter Untuk Ringkasan Aktif</p>
    </div> -->

    <!-- EMPTY -->
    <div v-else class="has-text-centered" key="empty-1">
      <ProyekEmptyIcon height="230" />
      <p class="averta-bold mt-0">Tidak ada data Report</p>
    </div>

    <!-- </transition> -->

    <!-- Modal Tagihan -->
    <b-modal v-model="isModalInvoice">
      <div class="flex-center">
        <div class="modal-tagihan-wrapper overflow-auto">
          <img :src="require('@/assets/img/forgot-password.png')" alt="" />
          <p class="label-16 averta-bold mb-1 mt-5">Tagihan Sudah Terbayar</p>
          <p class="has-text-centered mb-5">
            Periksa dan pastikan seluruh informasi pembayaran telah benar dan <br />sesuai
          </p>

          <div v-if="isLoadingInvoice" class="c-w-100">
            <b-skeleton width="100%" height="100px" :animated="true"></b-skeleton>
          </div>

          <div v-else-if="!isLoadingInvoice && dataInvoice" class="form-modal-invoice bg-lightgray">
            <div class="border-bottom-dashed pb-4 mb-3">
              <p class="averta-bold label-14 mb-2">Pilih Tanggal Pembayaran</p>
              <b-datepicker
                v-model="selectedDatePaymentInvoice"
                :mobile-native="false"
                :min-date="minDatePaymentInvoice"
              >
                <template v-slot:trigger>
                  <div class="input-search-1 bg-white is-clickable px-3 flex-center-vertical">
                    <ScheduleIcon width="15" height="15" />
                    <p class="ml-2 label-14 averta-bold">{{ selectedDatePaymentInvoiceString }}</p>
                  </div>
                </template>
              </b-datepicker>
            </div>

            <div>
              <p class="averta-bold label-14 mb-2">Informasi Tagihan</p>
              <div class="border-radius-12 overflow-hidden bg-white flex-center-vertical py-3">
                <div class="px-4 flex-1 border-right-2">
                  <p class="color-grey label-14 mb-1">ID/No. Invoice</p>
                  <p class="averta-bold label-14">
                    {{ tempDataProject.survey_id }}/{{ dataInvoice.invoice }}
                  </p>
                </div>
                <div class="px-4 flex-1">
                  <p class="color-grey label-14">Grand Total Tagihan</p>
                  <p class="color-orange-2 averta-bold">
                    {{ formatIdr(dataInvoice.price.grand_total) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isLoadingInvoice" class="c-w-100 mt-3">
            <b-skeleton width="100%" height="40px" :animated="true"></b-skeleton>
          </div>

          <div v-else-if="!isLoadingInvoice && dataInvoice" class="flex-center c-w-100 mt-3">
            <ButtonApp :isSecondary="true" class="flex-1 mr-2" @click="handleCloseModalInvoice">
              <p class="py-2 averta-bold">Kembali</p>
            </ButtonApp>
            <ButtonApp class="flex-1" @click="onClickFinishPayment">
              <p class="py-2 averta-bold">Sudah Terbayar</p>
            </ButtonApp>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- TOOLTIP -->
    <div
      v-if="tooltip.visible"
      class="tooltip-selected-wrapper"
      :style="{
        top: `${tooltip.y}px`,
        left: `${tooltip.x}px`
      }"
      ref="tooltip"
    >
      <!-- @mouseenter="tooltipVisible = true"
      @mouseleave="tooltipVisible = false" -->
      <AdditionalHeaderTooltipProgress
        v-if="tooltip.data"
        :indexColumnProps="tooltip.data.index_column"
        :dataTooltipFlagingProps="tooltip.data.flaging"
        :handleConfirmTooltipProps="handleConfirmTooltip"
      />

      <!-- HEADER -->
      <div class="header-tooltip">
        <div
          v-if="!tooltip.loading && tooltip.data"
          class="flex-center-vertical is-justify-content-space-between c-w-100"
        >
          <div>
            <p class="averta-bold label-16">
              {{ tooltip.data.survey_id }} | {{ tooltip.data.store_name }}
            </p>
            <p>Status: {{ titleStatus(tooltip.data.status_name) }}</p>
          </div>
          <div class="is-flex is-flex-direction-column is-align-items-flex-end">
            <!-- <TagStatus title="started" />
            <TagStatus title="no-slot-yet" />

            <TagStatus title="continued" />
            <TagStatus title="un-assigned" />

            <TagStatus title="continued" />
            <TagStatus title="not-checked-in" />

            <TagStatus title="continued" />
            <TagStatus title="checked-in" /> -->
            <TagStatus
              v-if="'worker_absent' in tooltip.data"
              :title="tooltip.data.worker_absent ? 'checked-in' : 'not-checked-in'"
            />
          </div>
          <!-- <div class="status-survey px-2" :class="getClassName(tooltip.data.status_name)">
            <p class="label-12 has-text-centered">
              {{ titleStatus(tooltip.data.status_name) }}
            </p>
          </div> -->
        </div>
        <div v-else class="c-w-100">
          <b-skeleton width="50%" :animated="true"></b-skeleton>
          <b-skeleton width="30%" :animated="true"></b-skeleton>
        </div>
      </div>

      <!-- BODY -->
      <div
        v-if="!tooltip.loading && tooltip.data && tooltip.data.history_late"
        class="body-tooltip"
      >
        <div class="is-flex is-justify-content-space-between">
          <!-- CATATAN PROYEK -->
          <div class="c-w-100">
            <!-- CATATAN KETERLAMBATAN -->
            <div
              v-if="tooltip.data.history_late.length > 0"
              class="bg-pink-11 border-radius-7 px-2 pb-2 pt-1 my-1 mb-2"
            >
              <div class="is-flex is-justify-content-space-between">
                <p class="color-grey label-12">Catatan Keterlambatan</p>
                <p class="color-grey label-12">Tanggal</p>
              </div>
              <div class="history-late">
                <div
                  v-for="(item, index) in tooltip.data.history_late"
                  :key="`late-${index}`"
                  :class="{
                    'mb-1': index + 1 !== tooltip.data.history_late.length
                  }"
                  class="is-flex is-justify-content-space-between"
                >
                  <p class="averta-bold">{{ titleStatus(item.status_name) }}</p>
                  <div class="is-flex">
                    <p class="color-red averta-bold mr-1">
                      {{ formatDate(item.date_late, 'DD/MM/YYYY') }}
                    </p>
                    <p>({{ item.late }} Hari)</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="is-flex is-justify-content-space-between">
              <p class="mb-1 color-grey label-12">Catatan Proyek</p>
              <p class="mb-1 color-grey label-12">
                Terakhir diubah:
                {{ tooltip.data.date_note ? formatDate(tooltip.data.date_note, 'DD/MM/YY') : '-' }}
              </p>
            </div>
            <div class="flex-1 note-tooltip">
              <p class="color-grey label-14 line-height-15">
                {{ tooltip.data.note || '-' }}
              </p>
            </div>
          </div>

          <!-- CATATAN KETERLAMBATAN -->
          <!-- <div v-if="tooltip.data.history_late.length > 0" class="flex-1">
            <div class="note-tooltip ml-3 width">
              <p class="averta-bold mb-1">Catatan Keterlambatan</p>

              <div class="list-late-wrapper">
                <div
                  v-for="(item, index) in tooltip.data.history_late"
                  :key="`late-${index}`"
                  class="mb-1"
                  :class="{
                    'mb-1': index + 1 !== tooltip.data.history_late.length
                  }"
                >
                  <p class="averta-black label-14 line-height-15">
                    • {{ titleStatus(item.status_name) }}
                  </p>
                  <p class="color-gray label-12 ml-2">
                    {{ formatDate(item.date_late, 'DD/MM/YYYY') }} • Terlambat
                    {{ item.late }} Hari
                  </p>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="mt-3 flex-center-vertical">
          <div @click="closeTooltip" class="cancel-tooltip flex-center is-clickable">
            <!-- <XMarkIcon size="10" color="#E10009" /> -->
            <p class="color-red averta-bold">Tutup</p>
          </div>
          <div
            class="status-survey status-survey-red flex-1 ml-3 button-detail-tooltip is-clickable"
            @click="handleNavigateDetail"
          >
            <p class="label-14">
              {{
                tooltip.data.flaging.type === 'rejected' ||
                tooltip.data.flaging.type === 'can-reject'
                  ? 'Lihat Detail & Revisi Penawaran'
                  : 'Lihat Detail'
              }}
            </p>
          </div>
        </div>
      </div>

      <div v-else class="c-w-100 px-4 pt-3">
        <b-skeleton width="100%" height="120px" :animated="true"></b-skeleton>
      </div>
    </div>

    <!-- Loading Indicator -->
    <div class="loading-arrow">
      <!-- <div class="loading-arrow"> -->
      <p>Loading</p>
    </div>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'
import moment from 'moment'
import {
  formatDateHelper,
  formatCurrency,
  getStatusClassName,
  alertErrorMessage,
  compareBetweenDates,
  titleReportProgress,
  userMenuPermissions,
  toastMessage,
  convertToSummaryReportProgress
} from '@/helpers'

// Assets
import {
  SpinnerIcon,
  AlertIcon,
  ScheduleIcon,
  XMarkIcon,
  InfoOutlineIcon,
  ProyekEmptyIcon,
  CalendarIcon,
  ArrowNarrowUp,
  ArrowNarrowDown,
  ChevronIcon
} from '@/components/icons'
import confirmImage from '@/assets/img/delete-area-component.png'

// Components
import ButtonApp from '@/components/button/ButtonApp.vue'
import SummaryProgress from './components/SummaryProgress.vue'
import HeaderProgress from './components/HeaderProgress.vue'
import NavbarTableProgress from './components/NavbarTableProgress.vue'
import AccordionWeeklyProgress from './components/AccordionWeeklyProgress.vue'
import TotalWeeklyColumnProgress from './components/TotalWeeklyColumnProgress.vue'
import EmptyColumnProgress from './components/EmptyColumnProgress.vue'
import AdditionalHeaderTooltipProgress from './components/AdditionalHeaderTooltipProgress.vue'
import TagStatus from './components/TagStatus.vue'

import ListColumn from './components/ListColumn.vue'
import TotalDailyWeekly from './components/TotalDailyWeekly.vue'

export default {
  name: 'ReportProgress',
  components: {
    // Icons
    SpinnerIcon,
    // eslint-disable-next-line vue/no-unused-components
    AlertIcon,
    ScheduleIcon,
    // eslint-disable-next-line vue/no-unused-components
    XMarkIcon,
    // eslint-disable-next-line vue/no-unused-components
    InfoOutlineIcon,
    ProyekEmptyIcon,
    // eslint-disable-next-line vue/no-unused-components
    CalendarIcon,
    // eslint-disable-next-line vue/no-unused-components
    ArrowNarrowUp,
    // eslint-disable-next-line vue/no-unused-components
    ArrowNarrowDown,
    ChevronIcon,

    // Components
    ButtonApp,
    // eslint-disable-next-line vue/no-unused-components
    SummaryProgress,
    HeaderProgress,
    NavbarTableProgress,
    AccordionWeeklyProgress,
    TotalWeeklyColumnProgress,
    EmptyColumnProgress,
    AdditionalHeaderTooltipProgress,
    // eslint-disable-next-line vue/no-unused-components
    TagStatus,
    TotalDailyWeekly,
    ListColumn
  },
  data () {
    return {
      widthColumn: 260,
      widthColumnNav: 180,
      minWidthSideColumn: 195,
      heightColumn: 93,
      heightColumnNavStatus: 47,
      heightColumnNav: 47,
      heightColumnDaily: 60,
      heightColumnAccordion: 60,
      heightColumnWeekly: 60,
      maxHeightTable: 75,
      elementPointToday: '',
      showScrollToday: false,
      showBackToTop: false,
      navbarPosition: 0,
      isLittleScroll: false,
      highlightedItem: null,

      dropdownShortcut: false,
      selectedShortcut: null,

      isLoading: false,
      isLoadingTooltip: false,
      isLoadingInvoice: false,
      isLoadingTemp: false,
      isLoadingSummary: false,
      isFilterStatus: false,
      isShrink: false,
      filterSummary: false,
      dataSummary: null,
      dateSummary: null,
      dataProgress: [],
      dataMonthly: [],
      fromDate: null,
      toDate: null,

      // Invoice
      dataInvoice: null,
      isModalInvoice: false,
      selectedDatePaymentInvoice: null,
      tempDataProject: null,
      minDatePaymentInvoice: null,

      indexAccordionWeek: [],
      idxSelectedStatus: null,
      scaleTable: 1,
      topAccordion: '5.5em',

      // virtual-scroll-list
      // listColumn: ListColumn,
      tooltipVisible: false,
      fromButton: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      heightNavbar: 'dashboard/getNavbarHeight',
      tempDateScrollTo: 'report/getTempDateScrollTo',
      filterDate: 'report/getSaveDateFilterProgress',
      payloadFilterReport: 'report/getFilterReportProgress',
      tooltip: 'report/getTooltipCardProgress'
    }),
    selectedDatePaymentInvoiceString () {
      return this.selectedDatePaymentInvoice
        ? moment(this.selectedDatePaymentInvoice).format('DD/MM/YYYY')
        : ''
    },
    availableDates () {
      const result = this.dataProgress.flatMap((item) =>
        item.data.map((entry) => ({
          start: new Date(entry.date),
          end: new Date(entry.date)
        }))
      )
      return result
    },
    alreadyFiltered () {
      const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
      const payloadSummary = JSON.parse(localStorage.getItem('report_summary') || 'null')

      return isFiltered && payloadSummary
    },
    widthTableComputed () {
      return this.isShrink ? '100%' : `${this.widthColumn * 18 + this.widthColumnNav + 10}px`
    }
  },
  methods: {
    updateZoom (val) {
      // Scale from 0.7 (slider=0) to 1 (slider=100)
      this.scaleTable = 0.495 + (val / 100) * 0.505
    },
    jumpTo (type, el) {
      const element = document.querySelector(el)
      if (element) {
        element.scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
      } else {
        const {
          payloadSurveyId,
          payloadClients,
          payloadStores,
          payloadDates,
          payloadDueDates,
          payloadStatus
        } = this.payloadFilterReport

        const payload = {
          fromArrow: true,
          type,
          element: el
        }
        if (payloadSurveyId) payload.surveyId = payloadSurveyId
        if (payloadClients) payload.clients = payloadClients
        if (payloadStores) payload.stores = payloadStores
        if (payloadDueDates) payload.dueDates = payloadDueDates
        if (payloadStatus) payload.status = payloadStatus

        const dates = payloadDates || {
          start: moment(moment(new Date())).format('YYYY-MM-DD'),
          end: moment(new Date()).format('YYYY-MM-DD')
        }
        if (type === 'prev') {
          payload.date = {
            start: moment(dates.start).add(-1, 'days').format('YYYY-MM-DD'),
            end: dates.end
          }
        } else if (type === 'next') {
          payload.date = {
            start: dates.start,
            end: moment(dates.end).add(1, 'days').format('YYYY-MM-DD')
          }
        }

        this.getReportProgress(payload)

        // if (type === 'prev') {
        //   const payload = {
        //     url: this.url,
        //     startDate: temp,
        //     endDate: moment(this.filterDate.end).format('YYYY-MM-DD')
        //   }
        //   this.$store
        //     .dispatch('report/getListReportProgress', payload)
        //     .then(response => {
        //       const res = response.data.data
        //       if (res.table.length < 1) {
        //         toastMessage('Data tidak ditemukan', 'is-dark')
        //       } else {
        //       }
        //     })
        // } else {
        // }
      }
      // if (type === 'next') {
      //   let element = document.getElementById(`columnDate${indexMonth}${indexWeek}${indexDaily + 1}`)
      //   if (!element) {
      //     element = document.getElementById(`columnDate${indexMonth}${indexWeek + 1}0`)
      //   }
      //   if (!element) {
      //     element = document.getElementById(`columnDate${indexMonth + 1}00`)
      //   }
      //   if (!element) return
      //   element.scrollIntoView({
      //     block: 'start',
      //     behavior: 'smooth'
      //   })
      // } else {
      //   let element = document.getElementById(`columnDate${indexWeek}${indexDaily - 1}`)
      //   if (!element) {
      //     element = document.getElementById(`columnDate${indexWeek - 1}${dataWeeks[indexWeek - 1].data.length - 1}`)
      //   }
      //   element.scrollIntoView({
      //     block: 'start',
      //     behavior: 'smooth'
      //   })
      // }
    },
    scrollToColumn (target, highlight = true, block = 'center') {
      if (!target) return
      let element = this.$refs[target]
      if (Array.isArray(element)) {
        element = element[0]
      }

      if (element && typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })

        if (highlight) {
          setTimeout(() => {
            this.highlightedItem = target
          }, 1000)

          setTimeout(() => {
            this.highlightedItem = null
          }, 3000)
        }
      }
    },
    titleStatus (status) {
      return titleReportProgress(status)
    },
    adjustStickyPosition () {
      setTimeout(() => {
        if (this.heightNavbar) {
          this.navbarPosition = this.heightNavbar + 'px'
        }
      }, 500)
    },
    getColumnClass (indexColumn, date, surveyId, column) {
      const highlightKey = `column-${date}-${surveyId}-${column && column.status_name}`
      const isHighlighted = this.highlightedItem === highlightKey
      const classes = {
        'border-right-5': indexColumn === 1,
        'is-highlight': isHighlighted
      }

      if (!isHighlighted) {
        if (indexColumn === 8) {
          classes['bg-grey-3'] = true
        }
        if (column) {
          if (column.background === 'danger') {
            classes['bg-pink-2'] = true
          } else if (column.background === 'warning') {
            classes['bg-light-orange-1'] = true
          }
        }
      }

      return classes
    },
    getZoom () {
      return window.devicePixelRatio || 1
    },
    formatDate (date, format) {
      if (!date) return ''
      return formatDateHelper({ date, format })
    },
    formatIdr (value) {
      if (!value) return '-'
      return formatCurrency(value)
    },
    formatMonth (props = {}) {
      const { start, end } = props
      if (!start && !end) return '-'
      const formatStart = moment(start).format('MMMM YYYY')
      const formatEnd = moment(end).format('MMMM YYYY')

      if (formatStart === formatEnd) return formatStart

      return `${formatStart} - ${formatEnd}`
    },
    formatTitleSummary (title) {
      if (!title) return '-'
      const checkString = ['SM', 'BS', 'SPK', 'SIK']

      let result = title.replace(/-/g, ' ')

      checkString.forEach((str) => {
        const pattern = new RegExp(str.toLowerCase(), 'g')
        result = result.replace(pattern, str)
      })

      result = result.replace(/\b\w/g, function (char) {
        return char.toUpperCase()
      })

      return result
    },
    countValueInsideArray (arrayDaily) {
      if (!arrayDaily || arrayDaily.length < 1) {
        return 0
      }

      let total = 0
      for (let i = 0; i < arrayDaily.length; i++) {
        total += arrayDaily[i].completed
      }

      return total
    },
    isEmptyRow (data) {
      return data.every((obj) => (!obj ? true : Object.keys(obj).length === 0))
    },
    isOverlapBody (idElement, idElementChild) {
      this.$nextTick(() => {
        const element = document.querySelector(`#${idElement}`)
        // (100 * px / window.innerHeight);

        const elementChild = document.querySelector(`#${idElementChild}`)
        const tableContainer = document.querySelector('.table-container')
        if (element && elementChild && tableContainer) {
          const countHeight =
            tableContainer.clientHeight - this.heightColumnNav - this.heightColumnDaily
          if (element.clientHeight >= countHeight) {
            // elementChild.style.marginBottom = `${this.heightColumnDaily}px`
            elementChild.style.position = 'sticky'
            // elementChild.style.paddingTop = '27px'
            // elementChild.style.top = `${(countHeight - this.heightColumnDaily - 10) / 2}px`
            // elementChild.style.top = `${(100 * element.offsetHeight) / window.innerHeight / 2.5}vh`
            elementChild.style.top = '37vh'

            return true
          }
          elementChild.style.position = 'relative'
          elementChild.style.top = `calc(${
            (element.clientHeight - this.heightColumnDaily) / 2
          }px - ${this.heightColumn / 2}px)`
        }
      })
      return false
    },
    getClassName (status) {
      return getStatusClassName(status)
    },
    getFilterSummary (props = {}) {
      const { surveyId, clients, stores, date, dueDates, status, summary } = props

      this.isLoadingSummary = true

      const payload = {
        path: 'summary'
      }

      if (surveyId) {
        payload.surveyId = surveyId
      }
      if (clients) {
        payload.clients = clients
      }
      if (stores) {
        payload.stores = stores
      }
      if (date) {
        if (!surveyId && date.start) {
          payload.startDate = date.start
          payload.endDate = date.end
        } else if (!surveyId) {
          payload.endDate = date
        }
      } else {
        if (!surveyId) {
          payload.startDate = moment(new Date()).format('YYYY-MM-DD')
          payload.endDate = moment(new Date()).format('YYYY-MM-DD')
        }
      }
      if (dueDates) {
        payload.startDueDate = dueDates.start
        payload.endDueDate = dueDates.end
      }
      if (status) {
        payload.status = status
        this.isFilterStatus = true
      } else {
        this.isFilterStatus = false
      }
      if (summary) {
        payload.summary = summary
      }

      if (surveyId || clients || stores || date || dueDates || status || summary) {
        localStorage.setItem('report_clicked_filter', true)
      } else {
        localStorage.setItem('report_clicked_filter', false)
      }

      this.$store
        .dispatch('report/getListReportProgress', payload)
        .then((response) => {
          this.dataSummary = {
            list: response.data.data
          }
          this.isLoadingSummary = false
          this.filterSummary = true
        })
        .catch((err) => {
          this.isLoadingSummary = false
          alertErrorMessage(err)
        })
    },
    getReportProgress (props = {}) {
      // eslint-disable-next-line no-unused-vars
      const {
        surveyId,
        clients,
        stores,
        date,
        dueDates,
        status,
        summary,
        fromArrow = false,
        // type = '',
        element = null
      } = props

      if (summary) {
        this.getFilterSummary(props)
        return
      }

      const el = document.querySelector('.loading-arrow')

      if (fromArrow) {
        this.isLoadingTemp = true
        if (el) {
          el.classList.add('position')
        }
      } else {
        this.isLoading = true
      }
      this.indexAccordionWeek = [] // open all acordion

      const payload = {
        path: 'table'
      }

      if (surveyId) {
        payload.surveyId = surveyId
      }
      if (clients) {
        payload.clients = clients
      }
      if (stores) {
        payload.stores = stores
      }
      if (date) {
        if (!surveyId && date.start) {
          payload.startDate = date.start
          payload.endDate = date.end
        } else if (!surveyId) {
          payload.endDate = date
        }
      } else {
        if (!surveyId) {
          payload.startDate = moment(new Date()).format('YYYY-MM-DD')
          payload.endDate = moment(new Date()).format('YYYY-MM-DD')
        }
      }
      if (dueDates) {
        payload.startDueDate = dueDates.start
        payload.endDueDate = dueDates.end
      }
      if (status) {
        payload.status = status
        this.isFilterStatus = true
      } else {
        this.isFilterStatus = false
      }
      if (summary) {
        payload.summary = summary.value
      }

      if (surveyId || clients || stores || date || dueDates || status || summary) {
        localStorage.setItem('report_clicked_filter', true)
      } else {
        localStorage.setItem('report_clicked_filter', false)
      }

      this.$store
        .dispatch('report/getListReportProgress', payload)
        .then((response) => {
          const res = response.data.data
          let no = 0

          if (fromArrow && res.table.length < 1) {
            toastMessage('Data tidak ditemukan', 'is-dark')
            return false
          }

          this.dataMonthly = res.monthly
          const resTable = res.table.map((itemTable) => ({
            ...itemTable,
            data: itemTable.data.map((itemData) => ({
              ...itemData,
              no: no++,
              is_overlap: false
            }))
          }))

          // let lastIncludedWeek = 0

          // this.dataProgress = this.dataMonthly.map(month => {
          //   const filteredTable = resTable.filter(row => row.week > lastIncludedWeek && row.week <= month.show_after_week)
          //   lastIncludedWeek = month.show_after_week
          //   return {
          //     ...month,
          //     table: filteredTable
          //   }
          // })
          this.dataProgress = resTable

          this.isLoading = false
          this.isLoadingTemp = false

          if (el) {
            el.classList.remove('position')
            el.classList.remove('opacity')
          }

          // this.$nextTick(() => {
          //   this.dataProgress.map((itemMonth, indexMonth) => {
          //     itemMonth.table.map((itemTable, indexTable) => {
          //       itemTable.data.map((itemDaily, indexDaily) => {
          //         this.isOverlapBody(`columnDate${indexMonth}${indexTable}${indexDaily}`, `columnDateChild${indexMonth}${indexTable}${indexDaily}`)
          //       })
          //     })
          //   })
          // })
          this.$nextTick(() => {
            this.dataProgress.map((itemTable, indexTable) => {
              itemTable.data.map((itemDaily, indexDaily) => {
                this.isOverlapBody(
                  `columnDate${indexTable}${indexDaily}`,
                  `columnDateChild${indexTable}${indexDaily}`
                )
              })
            })
          })

          this.fromDate = res.summary.from_date
          this.toDate = res.summary.to_date

          this.showScrollToday = compareBetweenDates({ start: this.fromDate, end: this.toDate })

          setTimeout(() => {
            if (this.tempDateScrollTo && this.tempDateScrollTo.startDate) {
              this.scrollToColumn(
                `column-${this.tempDateScrollTo.date_late}-${this.tempDateScrollTo.survey_id}-${this.tempDateScrollTo.status_name}`
              )

              this.$store.commit('report/setTempDateScrollTo', null)
            }
          }, 1000)

          setTimeout(() => {
            const getScrollTable = localStorage.getItem('report_scroll_table')
            if (getScrollTable && this.$refs.scrollTableContainer) {
              this.$refs.scrollTableContainer.scrollTop = JSON.parse(getScrollTable).scrollTop
              this.$refs.scrollTableContainer.scrollLeft = JSON.parse(getScrollTable).scrollLeft
              window.scrollTo(0, getScrollTable)
              localStorage.removeItem('report_scroll_table')
            }
          }, 500)

          const temp = localStorage.getItem('report_status')
          if (temp && JSON.parse(temp)) {
            this.idxSelectedStatus = JSON.parse(temp) && JSON.parse(temp).idx_column_report
            if (this.idxSelectedStatus && !this.isLoading) {
              setTimeout(() => {
                if (this.$refs.navbarProgress) {
                  this.$refs.navbarProgress.scrollTo(this.idxSelectedStatus)
                }
              }, 1500)
            }
          } else {
            this.idxSelectedStatus = null
          }

          if (fromArrow) {
            this.$nextTick(() => {
              const elChild = document.querySelector(element)
              if (elChild) {
                elChild.scrollIntoView({
                  block: 'start',
                  behavior: 'smooth'
                })
              }
              this.handleScrollTableContainer()
            })
            // let elChild = null
            // if (type === 'prev') {
            //   elChild = document.querySelector('.jump-0') // nomor
            //   setTimeout(() => {
            //     if (elChild) {
            //       elChild.scrollIntoView({
            //         block: 'start',
            //         behavior: 'smooth'
            //       })
            //     }
            //   }, 1000)
            // } else {
            //   this.jumpTo('next', element)
            // }
            this.fromButton = true
          } else {
            this.dataSummary = res.summary
            if (this.dataSummary.from_date === this.dataSummary.to_date) {
              this.dateSummary = this.formatDate(this.dataSummary.from_date, 'DD/MM/YYYY')
            } else {
              this.dateSummary = `${this.formatDate(this.dataSummary.from_date, 'DD/MM/YYYY')} - ${this.formatDate(this.dataSummary.to_date, 'DD/MM/YYYY')}`
            }

            // const parentData = res.table[0].data[0]
            // this.dataSummary.list = convertToSummaryReportProgress(parentData.total_day)

            localStorage.setItem('report_due_dates', JSON.stringify(props.data))
            this.$store.commit('report/setFilterReportProgress', { data: date, type: 'dates' })
            this.fromButton = false
          }
        })
        .catch((err) => {
          this.isLoading = false
          this.isLoadingTemp = false
          if (el) {
            el.classList.remove('position')
            el.classList.remove('opacity')
          }
          alertErrorMessage(err)
        })
    },
    handleNavigateDetail () {
      let routeData

      if (this.tooltip.data.project_id) {
        routeData = this.$router.resolve({
          path: `/am/project/${this.tooltip.data.project_id}/detail`
        })
      } else {
        routeData = this.$router.resolve({
          path: `/am/project/survey/${this.tooltip.data.survey_id}/detail`
        })
      }

      window.open(routeData.href, '_blank')
    },
    handleAccordion (index) {
      const findArray = this.indexAccordionWeek.includes(index)
      if (findArray) {
        const findIndex = this.indexAccordionWeek.indexOf(index)
        this.indexAccordionWeek.splice(findIndex, 1)
      } else {
        this.indexAccordionWeek.push(index)
      }
    },
    fixTooltipSize () {
      const zoom = this.getZoom()
      if (this.$refs.tooltip) {
        this.$refs.tooltip.style.transform = `scale(${1 / zoom})`
      }
    },
    closeTooltip () {
      this.$store.commit('report/setTooltipCardProgress', { visible: false, data: null })
    },
    handleConfirmTooltip (type) {
      const minDate = new Date(this.tooltip.data.start_due_date)

      switch (type) {
        case 'can-reject':
          this.handleConfirmReject(this.tooltip.data)
          break
        case 'can-paid':
          this.tempDataProject = this.tooltip.data
          minDate.setDate(minDate.getDate() - 1)
          this.minDatePaymentInvoice = minDate
          this.selectedDatePaymentInvoice = new Date(this.tooltip.data.start_due_date)

          setTimeout(() => {
            this.handleConfirmInvoice()
          }, 50)
          break
        default:
          return type
      }
    },
    handleConfirmReject (data) {
      this.$swal({
        imageUrl: confirmImage,
        width: '400px',
        padding: '10px 10px 20px',
        title: '<p class="averta-bold label-18">Konfirmasi Penawaran Ditolak</p>',
        html: '<p class="averta-regular">Pastikan seluruh informasi penawaran telah<br/>sesuai</p>',
        showCancelButton: true,
        confirmButtonText: 'Ya, Penawaran Ditolak',
        cancelButtonText: 'Cek Kembali',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn-hapus-detail-component flex-1',
          cancelButton: 'btn-batal-detail-component flex-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.closeTooltip()

          const payload = {
            url: this.url,
            surveyId: data.survey_id
          }
          this.$store
            .dispatch('report/postRejectConfirm', payload)
            .then(() => {
              this.getReportProgress()

              this.$buefy.toast.open({
                message: `<p class="averta-regular"><span class="is-italic">${data.survey_id}</span> ${data.store_name}<span class="averta-bold ml-4">Penawaran Ditolak</span></p>`,
                type: 'is-black',
                duration: 3500
              })
            })
            .catch((err) => {
              alertErrorMessage(err)
            })
        }
      })
    },
    handleConfirmInvoice () {
      this.isLoadingInvoice = true
      this.isModalInvoice = !this.isModalInvoice

      this.$store
        .dispatch('project/getDataInvoice', {
          url: this.url,
          project_id: this.tempDataProject.project_id
        })
        .then((res) => {
          this.dataInvoice = res.data.data
          this.isLoadingInvoice = false
        })
        .catch((err) => {
          this.isLoadingInvoice = false
          alertErrorMessage(err)
        })
    },
    handleCloseModalInvoice () {
      this.isModalInvoice = false
    },
    handleResetStateInvoice () {
      this.dataInvoice = null
      this.selectedDatePaymentInvoice = null
      this.tempDataProject = null
      this.minDate = null
    },
    onSelectDatePaymentInvoice () {
      this.isOpenDatePaymentInvoice = !this.isOpenDatePaymentInvoice
    },
    onClickFinishPayment () {
      if (!this.selectedDatePaymentInvoice) {
        return alertErrorMessage('Mohon Pilih Tanggal Pembayaran')
      }
      this.$swal({
        imageUrl: confirmImage,
        width: '400px',
        padding: '10px 10px 20px',
        title: '<p class="averta-bold label-18">Konfirmasi Tagihan Sudah Dibayar</p>',
        html: '<p class="averta-regular">Pastikan seluruh informasi tagihan <br/>dan pembayaran telah sesuai</p>',
        showCancelButton: true,
        confirmButtonText: 'Ya, Konfirmasi',
        cancelButtonText: 'Cek Kembali',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn-hapus-detail-component flex-1',
          cancelButton: 'btn-batal-detail-component flex-1'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            url: this.url,
            project_id: this.tempDataProject.project_id,
            paid_date: moment(this.selectedDatePaymentInvoice).format('YYYY-MM-DD')
          }
          this.$store
            .dispatch('project/putConfirmPayment', payload)
            .then(() => {
              this.getReportProgress()

              this.$buefy.toast.open({
                message: `<p class="averta-regular"><span class="is-italic">${this.tempDataProject.survey_id}</span> ${this.tempDataProject.store_name}<span class="averta-bold ml-4">Ditandai Sudah dibayar</span></p>`,
                type: 'is-black',
                duration: 3500
              })
              this.handleCloseModalInvoice()
              this.handleResetStateInvoice()
            })
            .catch((err) => {
              alertErrorMessage(err)
              this.handleCloseModalInvoice()
              this.handleResetStateInvoice()
            })
        }
      })
    },
    handleScroll () {
      const scrollY = window.scrollY || window.pageYOffset

      if (!this.isLoading) {
        if (scrollY > 20) {
          this.isLittleScroll = true
        } else if (scrollY < 10) {
          this.isLittleScroll = false
        }
      }
    },
    handleScrollToday () {
      this.indexAccordionWeek = []
      setTimeout(() => {
        if (this.showBackToTop) {
          const tableContainer = document.querySelector('.table-container')

          if (tableContainer) {
            tableContainer.scrollTo({ top: 0, behavior: 'smooth' })
          }
        } else {
          const todayContainer = document.querySelector('.today')

          if (todayContainer) {
            todayContainer.scrollIntoView({
              behavior: 'smooth'
            })
          }
        }
      }, 100)
    },
    handleOpenShortcut () {},
    handleSelectShortcut (e) {},
    handleScrollTableContainer () {
      // Get the reference to the scrollable container
      const container = this.$refs.scrollTableContainer

      // Get the reference to the specific list item with the class 'item4'
      const todayElement = this.$refs.scrollTableContainer.querySelector('.today')

      // Check if the fourth list item is not visible
      if (todayElement) {
        const containerRect = container.getBoundingClientRect()
        const listItemRect = todayElement.getBoundingClientRect()

        const offset = container.clientHeight - this.heightColumn

        if (
          listItemRect.bottom < containerRect.top ||
          listItemRect.top > containerRect.bottom - offset
        ) {
          this.showBackToTop = false
        } else {
          this.showBackToTop = true
        }
      }

      // For Summary when click Arrow
      if (!this.fromButton) return

      const box = container
      const parents = Array.from(box.querySelectorAll('.parent-box'))

      const active = { week: 0, daily: 0 }
      let closest = -Infinity
      const offset = 125 // bebas atur sesuai kebutuhan

      parents.forEach((el, idx) => {
        const rect = el.getBoundingClientRect()
        const parentRect = box.getBoundingClientRect()
        const distance = rect.top - parentRect.top

        // tambahin offset → dianggap "nyentuh" kalau sudah lewat offset
        if (distance <= offset && distance > closest) {
          closest = distance
          active.week = Number(el.dataset.week)
          active.daily = Number(el.dataset.daily)
        }
      })

      const parentData = this.dataProgress[active.week].data[active.daily]
      if (parentData) {
        this.dataSummary.list = convertToSummaryReportProgress(parentData.total_day)
        this.dateSummary = this.formatDate(parentData.date, 'DD/MM/YYYY')
      }
    },
    handleClickArrow (item) {
      const selectedDate = moment(item.date_late, 'YYYY-MM-DD')
      if (
        selectedDate.isBetween(
          this.dataSummary.from_date,
          this.dataSummary.to_date,
          undefined,
          '[]'
        )
      ) {
        this.scrollToColumn(`column-${item.date_late}-${item.survey_id}-${item.status_name}`)
      } else {
        const startDate = selectedDate.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD') // Monday
        const endDate = selectedDate.clone().endOf('week').add(1, 'days').format('YYYY-MM-DD') // Sunday
        this.$store.commit('report/setTempDateScrollTo', { ...item, startDate, endDate })
      }
    },
    handlePageRefresh () {
      const temp = {
        scrollTop: this.$refs.scrollTableContainer.scrollTop,
        scrollLeft: this.$refs.scrollTableContainer.scrollLeft
      }
      localStorage.setItem('report_scroll_table', JSON.stringify(temp))
    },
    adjustMaxHeightTable (val) {
      if (val < 0.555) {
        this.maxHeightTable = 50 / this.scaleTable
        this.topAccordion = '10.5em'
      } else if (val < 0.5758) {
        this.topAccordion = '10.5em'
        this.maxHeightTable = 49 / this.scaleTable
      } else if (val < 0.597) {
        this.topAccordion = '10.5em'
        this.maxHeightTable = 47 / this.scaleTable
      } else if (val < 0.69) {
        this.topAccordion = '7.8em'
        this.maxHeightTable = 53 / this.scaleTable
      } else {
        this.topAccordion = '6em'
        this.maxHeightTable = 75
      }

      // for width column
      if (val < 0.6) {
        this.widthColumn = 150
        this.heightColumnNavStatus = 70
        this.heightColumnDaily = 60
        this.heightColumnWeekly = 60
        this.isShrink = true
      } else {
        this.isShrink = false
        this.widthColumn = 260
        this.heightColumnNavStatus = 50
        this.heightColumnDaily = 50
        this.heightColumnWeekly = 50
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    this.adjustStickyPosition()

    const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
    const payloadStatus = localStorage.getItem('report_status')
    const payload = {}

    if (isFiltered) {
      const payloadSurveyId = JSON.parse(localStorage.getItem('report_survey_id') || 'null')
      const payloadClients = JSON.parse(localStorage.getItem('report_selected_clients') || 'null')
      const payloadStores = JSON.parse(localStorage.getItem('report_selected_stores') || 'null')
      const payloadDates = JSON.parse(localStorage.getItem('report_dates') || 'null')
      const payloadDueDates = JSON.parse(localStorage.getItem('report_due_dates') || 'null')
      const payloadSummary = JSON.parse(localStorage.getItem('report_summary') || 'null')

      if (payloadSurveyId) payload.surveyId = payloadSurveyId
      if (payloadClients) payload.clients = payloadClients.result
      if (payloadStores) payload.stores = payloadStores.result
      if (payloadDates) payload.date = payloadDates.selectedDate
      if (payloadSummary) payload.summary = payloadSummary

      if (payloadDueDates) {
        payload.dueDates = payloadDueDates.selectedDate || payloadDueDates
      }
      if (payloadStatus) {
        payload.status = JSON.parse(payloadStatus) ? JSON.parse(payloadStatus).afterTitle : null
      }
    } else {
      payload.initial = true
      this.isFilterStatus = false
    }
    this.getReportProgress(payload)

    if (localStorage.getItem('report_zoom_slider')) {
      this.updateZoom(localStorage.getItem('report_zoom_slider'))
    }

    this.scaleTable = 0.495 + (0 / 100) * 0.505
    setTimeout(() => {
      this.adjustMaxHeightTable(this.scaleTable)
    }, 100)

    this.fixTooltipSize()
    window.addEventListener('resize', this.fixTooltipSize)

    // function updateScale () {
    //   const zoom = window.devicePixelRatio || 1
    //   const inverseScale = 1 / zoom

    //   const header = document.querySelector('.scaled-wrapper')
    //   if (header) {
    //     header.style.transform = `scale(${inverseScale})`
    //     header.style.transformOrigin = 'top left'
    //     header.style.width = `${100 * zoom}%`

    //     // Get true scaled height via getBoundingClientRect
    //     const rect = header.getBoundingClientRect()
    //     const scaledHeight = rect.height
    //     const originalHeight = header.offsetHeight
    //     const heightDiff = originalHeight - scaledHeight

    //     header.style.setProperty('margin-bottom', `-${heightDiff}px`, 'important')

    //     const summary = document.querySelector('.scaled-summary')
    //     if (summary) {
    //       summary.style.setProperty('margin-top', `${heightDiff}px`, 'important')
    //     }
    //   }
    // }

    // window.addEventListener('resize', updateScale)
    // window.addEventListener('load', updateScale)
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
    if (!userMenuPermissions('MN_RPRT') && !userMenuPermissions('MN_RPRT_PROGRESS')) {
      this.$router.push({ path: '/' })
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  },
  beforeRouteLeave (to, from, next) {
    const data = [
      'report_survey_id',
      'report_clicked_filter',
      'report_selected_clients',
      'report_selected_stores',
      'report_dates',
      'report_status',
      'report_due_dates',
      'report_dropdown_summary',
      'report_summary',
      'report_dropdown_stores',
      'report_dropdown_clients'
    ]
    for (const item of data) {
      localStorage.removeItem(item)
    }
    this.$store.commit('report/setSelectedClients', 'reset')
    next()
  },
  beforeRouteEnter (to, from, next) {
    // `this` is NOT available here, because component instance is not created yet
    console.log('Navigating from:', from.fullPath, 'to:', to.fullPath)

    // Option 1: Allow navigation
    next()

    // Option 2: Cancel navigation
    // next(false)

    // Option 3: Redirect to another route
    // next('/login')
  },
  watch: {
    heightNavbar (val) {
      if (val) {
        this.adjustStickyPosition()
      }
    },
    tooltipVisible (val) {
      let payload = {
        hover_tooltip: val
      }
      if (!val) {
        payload = { ...payload, x: 0, y: 0, visible: false }
      }
      this.$store.commit('report/setTooltipCardProgress', payload)
    },
    scaleTable (val) {
      this.adjustMaxHeightTable(val)
    },
    tooltip: {
      handler (val) {
        if (val.visible) {
          this.fixTooltipSize()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/scss/_variables.scss';

.report-progress-container {
  height: calc(94vh - 65px);
  position: relative;
  margin-bottom: 10px !important;
}

.table-container {
  overflow: auto;
  position: relative;
  margin-top: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom: 1px solid #e1e1e1;
}

.monthly-wrap {
  position: relative;
}

.weekly-wrap {
  position: relative;
  background: $color-white;
}

.per-section {
  // max-height: 900vh; // try another way
  transition: 0.4s max-height ease-in-out;
}

.per-section.close {
  overflow: clip;
  max-height: 0px; // heightColumnDaily
}

.column-date {
  border: 1px solid $color-grey-10;
  border-top-width: 0;
  background: $color-grey-6;
  display: flex;
  align-items: center;
  flex-direction: column;
  z-index: 2;
  scroll-margin: 93px;
}

.shrink-side {
  flex: 0 0 7%;
}

.nav-table-shrink {
  flex: 1;
  min-width: 0;
}

.column-date-child {
  background: $color-grey-6;
}

.daily-column {
  border: 1px solid $color-grey-10;
  border-left-width: 0;
  background: $color-purple-4;
  // background: #ffab6e;
  // color: white;
}

.daily-column.side,
.monthly-column.side {
  border-top-width: 1px;
  border-right-width: 0px;
}

.monthly-column {
  border: 1px solid $color-grey-10;
  border-left-width: 0;
  background: $color-pink-7;
}

// TOOLTIP

.tooltip-selected-wrapper {
  width: 430px;
  min-height: 230px;
  max-height: 310px;
  overflow: hidden;
  background: white;
  border-radius: 16px;
  box-shadow: 0px 6px 24px 0px #2525251a;
  // position: absolute;
  // top: 3em;
  // right: -0.5em;
  // z-index: 20;
  position: fixed;
  transform-origin: top left;
  top: 0;
  left: 0;
  z-index: 99;
}

.header-tooltip {
  position: relative;
  z-index: 1;
  background: $color-grey-6;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.body-tooltip {
  padding: 15px;
  padding-top: 7px;
}

.note-tooltip {
  // background: #fff4f4;
  padding: 8px 10px;
  height: 80px;
  overflow: auto;
  border-radius: 8px;
  border: 1px solid #cbd5e1;
}

.note-tooltip.width {
  width: 210px;
}

.cancel-tooltip {
  height: 38px;
  // width: 38px;
  flex: 1;
  border-radius: 35px;
  border: 1px solid $color-red-1;
  overflow: hidden;
}

.button-detail-tooltip {
  padding: 20px 15px;
}

.list-late-wrapper {
  max-height: 80px;
  overflow-y: auto;
}

// TOOLTIP

.tooltip-footer {
  position: absolute;
  z-index: 9;
  right: 1em;
  bottom: 1.5em;
}

.scroll-today {
  opacity: 0.6;
  transition: 0.2s opacity ease-in-out;
}

.scroll-today:hover {
  opacity: 1;
}

.calendar-icon {
  border-radius: 100px;
  background: $color-red-1;
  padding: 10px;
  opacity: 0.6;
  cursor: pointer;
  transition: 0.2s opacity ease-in-out;
}

.calendar-icon:hover {
  opacity: 1;
}

.icon-today-wrapper {
  transform: rotate(180deg) scale(0.7);
  transition: 0.2s all ease-in-out;
}

.reverse {
  transform: rotate(0deg) scale(0.7);
}

.icon-today-wrapper img {
  height: 20px;
  transform: scale(1.7);
  margin-right: 5px;
}

.ellipse {
  width: 6px;
  height: 6px;
  margin-top: 1px;
}

.v-calendar-wrapper {
  width: 25em;
}

.prev-next-wrapper {
  position: absolute;
  right: 5px;
  top: 23px;
}

.btn-prev-next {
  cursor: pointer;
  // position: absolute;
  // margin-top: 10px;
  width: 30px;
  opacity: 0.2;
  transition: 0.1s opacity ease-in-out;

  &:hover {
    opacity: 0.5;
  }

  &.prev {
    transform: rotate(-90deg);
  }

  &.next {
    transform: rotate(90deg);
  }
}

.scaled-wrapper,
.scaled-summary,
.transform-origin-top-left {
  transform-origin: top left;
}

.scaled-wrapper {
  z-index: 25;
}

.monthly-report {
  position: sticky;
  bottom: 0;
  z-index: 9;
}

.loading-arrow {
  position: fixed;
  z-index: -1;
  bottom: 0;
  left: 48%;
  padding: 8px 17px;
  border-radius: 20px;
  background: #e10009;
  opacity: 0;
  color: white;
  box-shadow: #2525251a 0px 6px 24px 0px;
  transition: all 0.3s ease-in-out;
}

.loading-arrow.position {
  bottom: 4.5em !important;
  opacity: 1;
  z-index: 50;
}

.loading-arrow.opacity {
  opacity: 0.5;
}

.loading-arrow:hover {
  opacity: 1 !important;
}

.history-late {
  max-height: 30px;
  overflow: auto;
}
</style>

<style>
.date-report-progress-wrapper .datepicker .dropdown-content {
  box-shadow: none !important;
}
</style>
